import { useEffect, useRef } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";

import { Container, Row, Col } from "reactstrap";

import routes from "routes";


import './AuthStyle.css';

const Auth = (props) => {
  const mainContent = useRef(null);
  const location = useLocation();


  useEffect(() => {
     document.body.style.backgroundImage = "linear-gradient(60deg,#0B2A45,#287B99)";
  }, []);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = () => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="main-content" ref={mainContent}>
        {/* <AuthNavbar /> */}
        <div className="py-7 py-lg-8">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                </Col>
              </Row>
            </div>
          </Container>
        </div>

        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Switch>
              {getRoutes()}
              <Redirect from="*" to="/auth/login" />
            </Switch>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
